import { gql } from '@apollo/client';

// Content Queries
export const LIST_CONTENT = gql`
  query ListContent($input: ListContentInput) {
    listContent(input: $input) {
      items {
        contentId
        title
        slug
        excerpt
        contentType
        status
        featuredImage {
          mediaId
          objectKey
          alt
        }
        createdAt
        updatedAt
        createdBy
        updatedBy
      }
      nextToken
    }
  }
`;

export const GET_CONTENT = gql`
  query GetContent($contentId: ID!) {
    getContent(contentId: $contentId) {
      item {
        contentId
        version
        versionNumber
        title
        slug
        body {
          blocks {
            id
            type
            props
          }
        }
        excerpt
        contentType
        status
        featuredImage {
          mediaId
          objectKey
          alt
        }
        seo {
          title
          description
          keywords
        }
        createdAt
        updatedAt
        createdBy
        updatedBy
      }
      versionHistory {
        version
        versionNumber
        title
        slug
        status
        contentType
        updatedAt
        updatedBy
        archivedAt
      }
    }
  }
`;

// Content Mutations
export const CREATE_CONTENT = gql`
  mutation CreateContent($input: CreateContentInput!) {
    createContent(input: $input) {
      contentId
      title
      slug
      body {
        blocks {
          id
          type
          props
        }
      }
      excerpt
      contentType
      status
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_CONTENT = gql`
  mutation UpdateContent($contentId: ID!, $input: UpdateContentInput!) {
    updateContent(contentId: $contentId, input: $input) {
      contentId
      versionNumber
      title
      slug
      body {
        blocks {
          id
          type
          props
        }
      }
      excerpt
      contentType
      status
      updatedAt
      updatedBy
    }
  }
`;

export const DELETE_CONTENT = gql`
  mutation DeleteContent($contentId: ID!) {
    deleteContent(contentId: $contentId) {
      contentId
      status
      updatedAt
    }
  }
`;

// Media Queries
export const LIST_MEDIA = gql`
  query ListMedia($input: ListMediaInput) {
    listMedia(input: $input) {
      items {
        mediaId
        filename
        mediaType
        contentType
        objectKey
        uploadedAt
        uploadedBy
        altText
        size
        status
      }
      nextToken
    }
  }
`;

export const GET_MEDIA = gql`
  query GetMedia($mediaId: ID!) {
    getMedia(mediaId: $mediaId) {
      mediaId
      filename
      mediaType
      contentType
      bucket
      objectKey
      uploadedAt
      uploadedBy
      altText
      size
      status
      accessUrl
    }
  }
`;

// Media Mutations
export const CREATE_PRESIGNED_UPLOAD = gql`
  mutation CreatePresignedUpload($input: CreatePresignedUploadInput!) {
    createPresignedUpload(input: $input) {
      item {
        mediaId
        filename
        mediaType
        objectKey
        uploadedAt
      }
      uploadUrl
    }
  }
`;

export const DELETE_MEDIA = gql`
  mutation DeleteMedia($mediaId: ID!) {
    deleteMedia(mediaId: $mediaId) {
      success
      message
    }
  }
`;

// Settings
export const GET_SETTINGS = gql`
  query GetSettings {
    getSettings {
      siteTitle
      siteDescription
      navLinks {
        label
        href
      }
      lastPublishAt
      lastPublishSummary {
        publishedAt
        pagesGenerated
        contentItems
        durationMs
        invalidationId
      }
    }
  }
`;

export const UPDATE_SETTINGS = gql`
  mutation UpdateSettings($input: UpdateSettingsInput!) {
    updateSettings(input: $input) {
      siteTitle
      siteDescription
      navLinks {
        label
        href
      }
    }
  }
`;

// Publish
export const PUBLISH = gql`
  mutation Publish {
    publish {
      publishedAt
      pagesGenerated
      contentItems
      durationMs
      invalidationId
    }
  }
`;

// Users
export const LIST_USERS = gql`
  query ListUsers {
    listUsers {
      items {
        userId
        username
        email
        status
        groups
        createdAt
        enabled
      }
    }
  }
`;

export const INVITE_USER = gql`
  mutation InviteUser($input: InviteUserInput!) {
    inviteUser(input: $input) {
      userId
      username
      email
      status
      groups
      enabled
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser($userId: ID!, $input: UpdateUserInput!) {
    updateUser(userId: $userId, input: $input) {
      userId
      username
      email
      status
      groups
      enabled
    }
  }
`;

// Subscriptions
export const ON_CONTENT_UPDATED = gql`
  subscription OnContentUpdated($contentId: ID) {
    onContentUpdated(contentId: $contentId) {
      contentId
      title
      status
      updatedAt
      updatedBy
    }
  }
`;

export const ON_CONTENT_CREATED = gql`
  subscription OnContentCreated {
    onContentCreated {
      contentId
      title
      contentType
      createdAt
      createdBy
    }
  }
`;

export const ON_MEDIA_UPLOADED = gql`
  subscription OnMediaUploaded {
    onMediaUploaded {
      mediaId
      filename
      mediaType
      uploadedAt
    }
  }
`;
